import { render, staticRenderFns } from "./FPotensIKawasanJalan.vue?vue&type=template&id=2723ce6e&scoped=true"
import script from "./FPotensIKawasanJalan.vue?vue&type=script&lang=js"
export * from "./FPotensIKawasanJalan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723ce6e",
  null
  
)

export default component.exports